import { CommonModule, NgClass, NgIf } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { CaseDetailComponent } from '../../../abacus/components/case-detail.component'
import { ActionType } from '../../../abacus/enums/action-type.enum'
import { InputType } from '../../../abacus/enums/input-type.enum'
import { ResourceMode } from '../../../abacus/enums/resource-mode.enum'
import { Action } from '../../../abacus/interfaces/actions/action.interface'
import { ResourceDefinition } from '../../../abacus/interfaces/resource-definition.interface'
import { TruncatePipe } from '../../../abacus/pipes/truncate.pipe'
import { BreadcrumbService } from '../../../abacus/services/breadcrumb.service'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'
import { ResourceService } from '../../../abacus/services/resource.service'
import { ActionDirective } from '../../../abacus/standalone-exports'
import { Entity } from '../../../common/enums/entity.enum'
import { Status } from '../../../common/enums/status.enum'
import { ChangeHistoryComponent } from '../../../components/change-history/change-history.component'
import { metricUseCaseDefinition } from '../metric-use-case.definition'

@Component({
  selector: 'app-metric-use-case-detail',
  templateUrl: './metric-use-case-detail.component.html',
  styleUrls: ['./metric-use-case-detail.component.scss'],
  imports: [
    CommonModule,
    NgIf,
    NgClass,
    ReactiveFormsModule,
    FormsModule,
    TruncatePipe,
    ActionDirective,
    RouterModule,
    ChangeHistoryComponent
  ],
  standalone: true
})
export class MetricUseCaseDetailComponent
  extends CaseDetailComponent
  implements OnInit
{
  definition: ResourceDefinition = metricUseCaseDefinition

  publishAction: Action
  deleteAction: Action

  rejectAction: Action
  pendingAction: Action

  Status = Status
  Entity = Entity

  mucRelations = [
    { label: 'Purposes', propName: 'purposes' },
    { label: 'Target Sectors', propName: 'targetSectors' },
    { label: 'Objectives', propName: 'objectives' },
    { label: 'Risk Management Stages', propName: 'risks' }
  ]

  itemRelations = [
    ...this.mucRelations.map((relation) => relation.propName),
    'metrics'
  ]

  constructor(
    breadcrumbService: BreadcrumbService,
    resourceService: ResourceService,
    flashMessageService: FlashMessageService,
    activatedRoute: ActivatedRoute
  ) {
    super(
      breadcrumbService,
      resourceService,
      flashMessageService,
      activatedRoute
    )
  }

  async ngOnInit(): Promise<void> {
    await this.initDetailView()

    this.deleteAction = {
      type: ActionType.Delete,
      delete: {
        itemToDelete: this.item,
        definition: metricUseCaseDefinition,
        redirectTo: '/metric-use-cases'
      }
    }
    this.publishAction = {
      type: ActionType.Patch,
      patch: {
        path: `metric-use-cases/${this.item.id}/status`,
        body: { status: Status.Published },
        successMessage: 'The metric use case has been published !',
        errorMessage: 'Error: Metric use case could not be published'
      }
    }
    this.rejectAction = {
      type: ActionType.OpenCreateEditModal,
      openCreateEditModal: {
        title: `Reject the submission`,
        helpText: `You can provide a reason for rejecting the submission.`,
        definition: metricUseCaseDefinition,
        mode: ResourceMode.Patch,
        item: this.item,
        patchURL: `metric-use-cases/${this.item.id}/status`,
        fields: [
          {
            label: 'Rejection comment',
            property: 'rejectReason',
            placeholder: 'Explain why you are rejecting this submission.',
            className: 'is-12',
            inputType: InputType.Textarea
          },
          {
            label: 'Status',
            property: 'status',
            forcedValue: Status.Rejected,
            inputType: InputType.Select,
            hidden: true
          }
        ]
      }
    }
    this.pendingAction = {
      type: ActionType.Patch,
      patch: {
        path: `metric-use-cases/${this.item.id}/status`,
        body: { status: Status.Pending },
        successMessage: 'The metric use case has been switch to pending !',
        errorMessage: 'Error: Metric use case could not be rejected'
      }
    }
  }
}
